/*************************************
 *
 * 拼团路由管理
 *
 *************************************/

const groupBuy = [
  {
    path: '/groupBuy/index',
    name: 'Index',
    component: () => import('@/views/groupBuy/index/Index'),
    meta: {
      title: '爱拼团',
      keepAlive: true,
      auth: true,
      isWechat: true
    }
  },
  {
    path: '/groupBuy/orderDetail',
    name: 'OrderDetail',
    component: () => import('@/views/groupBuy/order/OrderDetail'),
    meta: {
      title: '订单详情',
      keepAlive: true,
      auth: true,
      isWechat: true
    }
  },
  {
    path: '/groupBuy/addressList',
    name: 'AddressList',
    component: () => import('@/views/groupBuy/address/AddressList'),
    meta: {
      title: '管理收货地址',
      keepAlive: true,
      auth: true,
      isWechat: true
    }
  },
  {
    path: '/groupBuy/addAddress',
    name: 'addAddress',
    component: () => import('@/views/groupBuy/address/AddAddress'),
    meta: {
      title: '更新地址',
      keepAlive: true,
      auth: true,
      isWechat: true
    }
  }
]

export default groupBuy



// WEBPACK FOOTER //
// ./src/router/modules/groupBuy.js